
<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-content">
    
    <form [formGroup]="formEdition"
      (submit)="onSubmit()"
      class="edit_form">
      
      <div class="edit_form__header">
        <h3>Editar</h3>
        <img class="modal-content-close"
          role="button"
          src="/assets/svgs/close_btn.svg" 
          alt="botão fechar"
          (click)="closeModal()"
        >
      </div>
      <div class="edit_form__body">

        <div class="container_phones">
          <app-input-dropdown-country-prefix-phone
            id="main_phone"
            [label]="'Telefone Principal'"
            [control]="formEdition.get('phone.phone')"
            [fieldName]="'telefone_principal'"
            [controlCountry]="formEdition.get('phone.ddi')"
            [required]="true">
          </app-input-dropdown-country-prefix-phone>

          <app-input-dropdown-country-prefix-phone
            id="alternative_phone"
            [label]="'Telefone Alternativo'"
            [control]="formEdition.get('alternative_phone.phone')"
            [fieldName]="'telefone_alternativo'"
            [controlCountry]="formEdition.get('alternative_phone.ddi')">
          </app-input-dropdown-country-prefix-phone>
        </div>
        <p class="equals_phone" *ngIf="formEdition.hasError('areEquals')">
          Telefones não devem ser iguais
        </p>
        
        <p class="info_whatsapp">
          Caso tenha WhatsApp, recomendamos que coloque-o no campo telefone principal
        </p>
        <app-input-text
          id="input-email"
          [label]="'E-mail'"
          [control]="formEdition.get('email')"
          [fieldName]="'email'"
          [disabled]="true"
          [placeholder]="'corretor@mail.com.br'">
        </app-input-text>

        <span class="title-input-biography">Biografia:</span>
        <app-input-text
          id="input-biography"
          [control]="formEdition.get('biography')"
          [fieldName]="'biografia'"
          [disabled]="disabledBiography"
          [placeholder]="'Escreva um breve resumo sobre você'"
          [maxlength]="280"
          [type]="'textarea'"
          height="104">
        </app-input-text>
        <div>
          <span class="validator__counter" *ngIf="maxLength">
            {{ formEdition.get('biography').value.length }}/{{ maxLength }}
          </span>
        </div>
      </div>

      <div class="edit_form__footer">
        <button class="btn-cancel"
          type="button"
          (click)="closeModal()">
          Cancelar
        </button>
        <button type="submit" 
          class="btn-save" 
          [disabled]="formEdition.invalid"
          [ngClass]="{'spinner spinner-white': loadingEdition}">
          Salvar
        </button>
      </div>
    </form>
  </div>
</div>